import { Module } from 'vuex';

import { Optional, RootState } from 'frontend/types';
import { Discount } from 'frontend/types/premium';

export interface Price {
  amount: string;
  for_display: string;
}

interface CancellationFlowDiscountState {
  subscription_id?: number;
  replaced_discount?: Discount;
  discount?: Discount;
  base_price?: Price; // number in currency format
  estimated_price?: Price; // number in currency format
}

const cancellationFlowDiscount: Module<CancellationFlowDiscountState, RootState> = {
  namespaced: true,
  state: {},
  mutations: {
    setValue(state: CancellationFlowDiscountState, value: CancellationFlowDiscountState): void {
      Object.assign(state, value);
    },
  },
  getters: {
    subscriptionId(state): Optional<number> {
      return state.subscription_id;
    },
    replacedDiscount(state): Optional<Discount> {
      return state.replaced_discount;
    },
    basePrice(state): Optional<Price> {
      return state.base_price;
    },
    estimatedPrice(state): Optional<Price> {
      return state.estimated_price;
    },
  },
};

export default cancellationFlowDiscount;
